<template>
  <v-app>
    <component v-bind:is="layout"></component>
  </v-app>
</template>

<script>
  import Default from '@/layouts/default'
  import Centered from '@/layouts/centered'

  export default {
    computed: {
      layout () {
        return this.$store.getters['pages/layout']
      }
    },
    components: {
      Default,
      Centered
    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue